import { Component, inject, Injector, Input, OnInit } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { ConverterService } from "../../../../../services/converter.service";
import { ToastrService } from "ngx-toastr";
import { TranslateService } from "@ngx-translate/core";
import { ObjectModel } from "../../../../../models/ObjectModel";
import { OdometerViewModel } from "../../../../../models/OdometerViewModel";
import { AccessRights, UsersService } from 'app/services/users.service';

@Component({
  selector: 'object-odometer-part',
  templateUrl: './object-odometer-part.component.html',
  styleUrls: ['./object-odometer-part.component.css'],
  standalone: false
})
export class ObjectOdometerPartComponent {

  @Input() Object: ObjectModel;

  @Input()
  private client: HttpClient;
  private converterService: ConverterService;
  private toastr: ToastrService;
  private translate: TranslateService;

  private usersService = inject(UsersService);
  public canEditTrackers: boolean = false;
  constructor(protected injector: Injector) {
    this.client = injector.get(HttpClient);
    this.converterService = injector.get(ConverterService);
    this.toastr = injector.get(ToastrService);
    this.translate = injector.get(TranslateService);
    this.canEditTrackers = this.usersService.getCurrentUser().CanDo(AccessRights.EDIT_TRACKERS);
  }

  get mileage(): number {
    return parseFloat(this.converterService.GetKMeters(this.Object.Odometer.Mileage));
  }

  set mileage(value: number) {
    this.Object.Odometer.Mileage = this.converterService.ParseKMeters(value);
  }

  get engineTime(): number {
    return this.Object.Odometer.EngineTime / 3600000;
  }

  set engineTime(value: number) {
    this.Object.Odometer.EngineTime = value * 3600000;
  }

  public syncDistance() {
    this.client.put("/ctrl/objects/SyncOdometer/" + this.Object.Id + "/" + this.Object.Odometer.Mileage, "")
      .subscribe((res) => {
        this.toastr.success(this.translate.instant("Synchronization was successfully done"));
        // this.onCreated.emit();
        // this.close();
        // super.submit();
      });
  }

  public syncEngineTime() {
    this.client.put("/ctrl/objects/SyncEngineTime/" + this.Object.Id + "/" + this.Object.Odometer.EngineTime, "")
      .subscribe((res) => {
        this.toastr.success(this.translate.instant("Synchronization was successfully done"));
        // this.onCreated.emit();
        // this.close();
        // super.submit();
      });
  }

  protected readonly ObjectModel = ObjectModel;
  protected readonly OdometerViewModel = OdometerViewModel;
}
